import { Button } from '@/components/Button.tsx'
import { useTranslation } from 'react-i18next'

export interface IOSHomescreenPreviewProps {
  thumbnailUrl: string | null
  onLinkClick?: () => void
  showButton?: boolean
}

export default function IOSHomescreenPreview({ thumbnailUrl, onLinkClick, showButton = true }: IOSHomescreenPreviewProps) {
  const { t } = useTranslation()

  if (!thumbnailUrl) {
    return null
  }

  return (
    <div className='flex flex-col items-center gap-4'>
      {/* iOS-style app icons preview */}
      <div className='flex flex-row items-end gap-3'>
        {/* Left placeholder icon */}
        <div className='w-[3.5rem] h-[3.5rem] rounded-[0.75rem] bg-base-300 opacity-50' />

        {/* Center - Album thumbnail as app icon */}
        <div
          className='w-[4.5rem] h-[4.5rem] rounded-[1rem] bg-cover bg-center shadow-lg'
          style={{ backgroundImage: `url(${thumbnailUrl})` }}
        />

        {/* Right placeholder icon */}
        <div className='w-[3.5rem] h-[3.5rem] rounded-[0.75rem] bg-base-300 opacity-50' />
      </div>

      {showButton && onLinkClick && (
        <Button color='primary' size='sm' onClick={onLinkClick}>
          {t('common.linkToHomescreenButton')}
        </Button>
      )}
    </div>
  )
}
